import React, { Fragment } from "react";
import "./index.css";
import { useHistory } from "react-router-dom";
import { BrowserView, MobileView } from "react-device-detect";
import { Layout, Row, Col, Typography, Button } from "antd";
import { InstagramOutlined } from "@ant-design/icons";
import I18n from "../../i18n";

const { Text, Title } = Typography;

export function Footer() {
  const history = useHistory();
  const goTo = (path: string) => history.push(path);

  const renderTitle = () => <div style={{ paddingBottom: 10 }}>
    <Title style={{ marginBottom: 10 }}>{I18n.title}</Title>
    <Text style={{}}>{'استایلی خاص برای شما ☺️'}</Text>
  </div>;

  const renderSocialIcons = () => (
    <div>
      <Row justify="center">
        <Button type="default" shape="round" style={{ backgroundColor: 'pink', marginLeft: 10 }} onClick={() => {
          window.location.assign('https://www.instagram.com/mezun_lennaa/')
        }}>
          <Row>
            <InstagramOutlined className="footer-social-icon" />
            {'مزون لنا'}
          </Row>
        </Button>
        <Button type="default" shape="round" style={{ backgroundColor: 'paleturquoise', marginRight: 10 }} onClick={() => {
          window.location.assign('https://www.instagram.com/lennastyle_scarf/')
        }}>
          <Row>
            <InstagramOutlined className="footer-social-icon" />
            {'لنا اسکارف'}
          </Row>
        </Button>

      </Row>
    </div>
  );

  const renderCustomerServicesMenu = () => (
    <Fragment>
      <Title level={4} className="footer-menu-title">
        {I18n.footer.customerServices}
      </Title>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/faq")} >
          {I18n.general.faq}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/terms")}>
          {I18n.general.termsAndConditions}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/privacy-policy")}
        >
          {I18n.general.privacyPolicy}

        </Button>
      </div>
    </Fragment>
  );

  const renderInfoMenu = () => (
    <Fragment>
      <Title level={4} className="footer-menu-title">
        {I18n.footer.info}
      </Title>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/about")}>
          {I18n.general.aboutUs}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/contact-us")} >
          {I18n.general.support}
        </Button>
      </div>
    </Fragment>
  );

  return (
    <Layout.Footer className="footer" style={{ backgroundColor: 'aliceblue', marginTop: 10 }}>
      <BrowserView>
        <Row className="footer-desktop">
          <Col xl={8} md={8}>
            {renderCustomerServicesMenu()}
          </Col>
          <Col xl={8} md={8}>
            {renderInfoMenu()}
          </Col>
          <Col xl={8} md={8}>
            {renderTitle()}
            {renderSocialIcons()}
          </Col>
        </Row>
      </BrowserView>
      <MobileView>
        {renderTitle()}
        {renderSocialIcons()}
        <Row className="footer-mobile">
          <Col span={12}>{renderCustomerServicesMenu()}</Col>
          <Col span={12}>{renderInfoMenu()}</Col>
        </Row>
      </MobileView>
      <div className="footer-copyright-notice">
        <Text>{I18n.footer.copyright.replace("{year}", "1401")}</Text>
      </div>
    </Layout.Footer>
  );
}
